export default __webpack_public_path__ + "static/media/Punto_11_Palazzi_dell_800_ITA_Def.db5d7a62.aac";